import Layout from "../components/layout/Layout";
import { Link as RouterLink } from "react-router-dom";
import { Box, Button, Container, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import ProfileIntroduction from "../components/users/UserDescription";
import UsersSection from "../components/users/UsersSection";
import reportWebVitals from "../reportWebVitals";
import GroupsSection from "../components/users/GroupsSection";
import Footer from "../components/layout/Footer";
import HomeIcon from "@mui/icons-material/Home";
import { useUsers, useAllGroups } from "../pages/api/api";

function ProfilePage() {
  const { t } = useTranslation();

  const userColumns: string[] = [t("Name"), t("Email"), t("Status")];
  const groupColumns: string[] = [
    t("Name"),
    t("Members"),
    t(""),
    t("") /*, t("Last Release")*/,
  ];

  //const { groups, isLoadingGroups, isErrorGroups } = useGroups();
  const { users, isLoadingUsers, isErrorUsers } = useUsers();
  const { allGroups, isLoadingAllGroups, isErrorAllGroups } = useAllGroups();

  return (
    <div>
      <Layout />
      <Container disableGutters={true} sx={{ mt: 3 }}>
        <Box mb={4}>
          <Button
            to="/"
            variant="outlined"
            startIcon={<HomeIcon />}
            component={RouterLink}
          >
            {t("Back to Home")}
          </Button>
        </Box>
        <ProfileIntroduction
          name={
            localStorage.getItem("Name") + " " + localStorage.getItem("Surname")
          }
          status={localStorage.getItem("Role")}
          users={users}
          groups={allGroups}
        />
        <Divider />
        {localStorage.getItem("Role") !== "USER" && (
          <Box>
            <UsersSection
              users={users}
              columns={userColumns}
              isLoading={isLoadingUsers}
              isError={isErrorUsers}
            />
            <Divider />
          </Box>
        )}
        <GroupsSection
          groups={allGroups}
          columns={groupColumns}
          users={users}
          isLoading={isLoadingAllGroups}
          isError={isErrorAllGroups}
        />
        <Divider />
      </Container>
      <div
        style={{
          position: "relative",
          left: 0,
          bottom: 0,
          right: 0,
          paddingTop: 40,
        }}
      >
        <Footer />
      </div>
    </div>
  );
}

export default ProfilePage;

reportWebVitals();
